import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import { Collage, CollageItem } from 'page/ProfileScreen/BasicSelfiesPanel/Collage'

const bad1_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/basic-selfie-bad-1-666b.jpg'
const bad2_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/basic-selfie-bad-2-a4e3.jpg'
const bad3_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/basic-selfie-bad-3-c864.jpg'
const good1_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/basic-type-selfie-2-ccb2.jpg'
const good2_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/basic-type-selfie-1-364d.jpg'
const good3_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/basic-type-selfie-3-6bb3.jpg'

const bad_images: [CollageItem, CollageItem, CollageItem] = [
  { src: bad1_jpg, size: 'tiny' },
  { src: bad2_jpg, size: 'small' },
  { src: bad3_jpg, size: 'large' },
]

const good_images: [CollageItem, CollageItem, CollageItem] = [
  { src: good1_jpg, size: 'large' },
  { src: good2_jpg, size: 'small' },
  { src: good3_jpg, size: 'tiny' },
]

export const SelfieExamples = observer(() => {
  return (
    <Space gap={44} center wrap>
      <Collage items={bad_images} badge="bad" back />
      <Collage items={good_images} badge="good" />
    </Space>
  )
})
